export const sceneSpheres = `
    vec3 sceneSpheres(vec3 rd, float time) {
        vec3 ro = vec3(0.,0.,time*4.); float t=0.;
        for(int i=0; i<32; i++) {
            vec3 p = ro + rd*t; vec3 rep = mod(p,4.)-2.;
            float d = length(rep)-0.9;
            if(d<0.01) {
                vec3 n=normalize(rep); float diff=max(dot(n,normalize(vec3(.5,.8,.5))),0.);
                return (vec3(.2,.5,1.)*diff + pow(diff,16.)) * (1./(1.+t*t*0.05));
            }
            t+=d; if(t>20.) break;
        }
        return vec3(0.);
    }
`;
